import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  fetchAllRequests,
  fetchAllRequestsCompleted,
} from "../../slices/all_requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleFetchAllRequests({ page, items }) {
  return await workflowsService.listUserRequest(page, items);
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* listAllRequestsSaga({ payload }) {
  try {
    yield put(fetchAllRequests());
    const allRequestsData = yield call(handleFetchAllRequests, payload);
    const usersTokens = allRequestsData.data.map((item) => item.user_token);
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    allRequestsData.data = allRequestsData.data.map((item) => {
      const user = usersData.find((user) => user.token === item.user_token);
      return {
        ...item,
        fullName: `${user.name} ${user.last_name}`,
      };
    });

    yield put(fetchAllRequestsCompleted(allRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* listAllRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_FETCH_LIST_ALL_REQUESTS,
    listAllRequestsSaga
  );
}
